import React, { Component } from 'react';
import Table from "../../../components/UI/Table/Table";
import { connect } from 'react-redux'
import './style.css';
import withAuth from '../../../components/Services/WithAuth';
import { getScoreCardList } from './actions'
// import { convertTime } from './helper'
import { tableColumns } from './constant.js';


class ScorecardListComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            value: '',
            selectedRiskType: 'qualitative',
            selectedOption: null
        };
        this.scorecardData=[];
    }
    componentDidMount(){
        this.props.getScoreCardList();
    }

    render() {
        return (

            <div className="col">
                <div className="scorecard-list">
                    <h3> List of computed scorecards</h3>
                    <Table
                        data={this.props.scorecardList}
                        columns={tableColumns}
                        defaultSorted={[
                            {
                                id: "updatedAt",
                                desc: false
                            }
                        ]}
                        defaultPageSize={10}
                        className="ComputedScorecardTable"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state,ownProps) => {
  
    return {
        scorecardList:state.scorecardReducer.scorecardList
    }
  }
  
const mapDispatchToProps = (dispatch) => {
    return {
        getScoreCardList: () => { dispatch(getScoreCardList()); }
    };
  };
  
  export default withAuth(connect(mapStateToProps, mapDispatchToProps)(ScorecardListComponent))
